/*
 * @Author: your name
 * @Date: 2020-10-22 13:24:39
 * @LastEditTime: 2021-03-19 17:02:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\api\index.js
 */
import request from '@/utils/request'


// export function musicBroadcastingDetails(params) {
//   return request({
//     url: `musicBroadcastingDetails?channelname=${params.channelname}`,
//     method: 'get',
//     data: params,
//     showLoading: true // loading效果
//   })
// }
// 登录账号
export function login(params) {
  return request({
    method: 'post',
    url: 'login/login',
    data: params
  })
}
// 退出系统
export function logOut() {
  return request({
    method: 'post',
    url: 'login/logout'
  })
}
// 查询平台管理员用户信息
export function queryUserList(params) {
  return request({
    method: 'post',
    url: 'user/queryUserList',
    data: params
  })
}
// 管理员添加平台管理员
export function addPlatformAdmin(params) {
  return request({
    method: 'post',
    url: 'user/addPlatformAdmin',
    data: params
  })
}
// 商安信接口
export function findMonitorTraceWaring(params) {
  return request({
    method: 'get',
    url: `user/findMonitorTraceWaring?waringDate=${params}`
  })
}
// 查询登录者账号信息
export function getUserInfo() {
  return request({
    method: 'post',
    url: 'user/accountInformation'
  })
}
// 查询登录者会员信息
export function userMemberInfo() {
  return request({
    method: 'post',
    url: 'user/userMemberInformation'
  })
}
// 查询用户头信息
export function findUserHead() {
  return request({
    method: 'post',
    url: 'user/findUserHead'
  })
}
// 删除会员信息
export function delUserMember(params) {
  return request({
    method: 'post',
    url: `user/delUserMember`,
    data: params
  })
}
// 修改或删除管理员信息
export function oprateUser(type, params) {
  return request({
    method: 'post',
    url: `user/updateOrDelUser?operationType=${type}`,
    data: params
  })
}
// 修改密码时先验证邮箱是否存在
export function checkEmail(params) {
  return request({
    method: 'get',
    url: `user/checkEmail?email=${params}`,
  })
}
export function sendCaptcha(params) {
  return request({
    method: 'get',
    url: `login/sendEmailCaptcha?email=${params}`,
  })
}
export function getCaptcha(params) {
  return request({
    method: 'post',
    url: `login/checkCaptcha`,
    data: params
  })
}
export function editEmail(params) {
  return request({
    method: 'post',
    url: `login/updateEmailOrPassword`,
    data: params
  })
}
export function getOprateData(params) {
  return request({
    method: 'post',
    url: `sysLog/findLogList`,
    data: params
  })
}
// 查询产品信息
export function getProductData(params) {
  return request({
    method: 'post',
    url: `product/findProduct`,
    data: params
  })
}
// 查询业务类型
export function getProductType(params) {
  return request({
    method: 'post',
    url: `product/findProductBusinessType`,
    data: params
  })
}
// 添加或编辑业务类型
export function addProductType(params) {
  return request({
    method: 'post',
    url: `product/addOrUpdateBusinessType`,
    data: params
  })
}
// 查询操作日志记录
export function getLogList(params) {
  return request({
    method: 'post',
    url: `sysLog/findLogList`,
    data: params
  })
}
// 查询所有申请记录
export function getRecordList(params) {
  return request({
    method: 'post',
    url: `applyRecord/findApplyRecordList`,
    data: params
  })
}
// 查询调查表修改前数据
export function findQuestionnaireInfoBack(id) {
  return request({
    method: 'get',
    url: `questionnaireInformation/findQuestionnaireInformationBackById?applyRecordId=${id}`
  })
}
// 查询审批历史数据
export function findApproveHistory(id) {
  return request({
    method: 'get',
    url: `applyRecord/findApproveHistoryList?applyId=${id}`
  })
}
// 接受任务或任务退回或委托指定人
export function taskManagement(params) {
  return request({
    method: 'post',
    url: `applyRecord/taskManagement`,
    data: params
  })
}
// 查询通告记录
export function findNoticeList(params) {
  return request({
    method: 'post',
    url: `sysNotice/findNoticeList`,
    data: params
  })
}
// 根据通告id查询通告详情
export function findNoticeById(id) {
  return request({
    method: 'get',
    url: `sysNotice/findNoticeById?id=${id}`
  })
}
// 添加通告
export function addNotice(params) {
  return request({
    method: 'post',
    url: `sysNotice/addNotice`,
    data: params
  })
}
// 编辑草稿箱-保存
export function saveNotice(params) {
  return request({
    method: 'post',
    url: `sysNotice/saveNotice`,
    data: params
  })
}
// 删除草稿箱
export function delNotice(id) {
  console.log(id);
  return request({
    method: 'post',
    url: `sysNotice/delNotice?id=${id}`,
  })
}
// 查看未读会员列表
export function findUnreadList(params) {
  return request({
    method: 'post',
    url: `sysNotice/findUnreadList`,
    data: params
  })
}
// 上传文件到腾讯云
export function uploadFile(params) {
  return request({
    method: 'post',
    url: `user/uploadFile`,
    data: params
  })
}
// 从腾讯云上下载文件
export function downLoadFile(name, url) {
  return request({
    method: 'get',
    url: `user/downFile?fileName=${name}&url=${url}`,
    responseType: 'blob' // 表明返回服务器返回的数据类型
  })
}
// 查询代办事项信息
export function findTodoList(params) {
  return request({
    method: 'post',
    url: `todoInformation/findTodoList`,
    data: params
  })
}
// 查询所有调查表年份信息
export function findSurveyYearList() {
  return request({
    method: 'get',
    url: `questionnaireManagement/findQuestionnaireManagement`
  })
}
// 添加或提醒调查表
export function addOrUpdateSurveyYear(params) {
  return request({
    method: 'post',
    url: `questionnaireManagement/saveOrWarnQuestionnaireManagement`,
    data: params
  })
}
// 查询某年调查表完成进度信息
export function findQuestionnairePlan(year) {
  return request({
    method: 'get',
    url: `questionnaireManagement/findQuestionnairePlan?year=${year}`
  })
}
export function findSurveyYear(id) {
  return request({
    method: 'get',
    url: `questionnaireManagement/findQuestionnaireYear?userId=${id}`
  })
}
// 查询缴费记录
export function findPaymentRecord(params) {
  return request({
    method: 'post',
    url: `paymentRecord/findPaymentRecord`,
    data: params
  })
}
// 添加缴费记录
export function paymentRecord(params) {
  return request({
    method: 'post',
    url: `paymentRecord/addOrUpdatePaymentRecord`,
    data: params
  })
}
// 删除缴费记录
export function deleteRecord(params) {
  return request({
    method: 'post',
    url: `paymentRecord/delPaymentRecord`,
    data: params
  })
}
// 查询联系人信息
export function findContactInfo(params) {
  return request({
    method: 'post',
    url: `contactInformation/findContactInformation`,
    data: params
  })
}
// 添加联系人信息
export function addContactInfo(params) {
  return request({
    method: 'post',
    url: `contactInformation/addOrUpdateContactInformation`,
    data: params
  })
}
// 删除联系人信息
export function delContactInfo(params) {
  return request({
    method: 'post',
    url: `contactInformation/delContactInformation`,
    data: params
  })
}
// 查询发票信息
export function findInvoiceInfo(id) {
  return request({
    method: 'get',
    url: `invoiceInformation/findInvoiceInformation?userId=${id}`
  })
}
// 添加或修改发票信息
export function addInvoiceInfo(params) {
  return request({
    method: 'post',
    url: `invoiceInformation/addOrUpdateInvoiceInformation`,
    data: params
  })
}
// 查询公司信息
export function findCompanyInfo(id) {
  return request({
    method: 'get',
    url: `companyInformation/findCompanyInformation?userId=${id}`
  })
}
// 添加或修改公司信息
export function addCompanyInfo(params) {
  return request({
    method: 'post',
    url: `companyInformation/addOrUpdateCompanyInformation`,
    data: params
  })
}
// 查询业务类型
export function findProBusType(params) {
  return request({
    method: 'post',
    url: `product/findProductBusinessType`,
    data: params
  })
}
// 查询资质及补贴信息、荣誉信息
export function findHonorInfo(params) {
  return request({
    method: 'post',
    url: `honorInformation/findHonorInformation`,
    data: params
  })
}
// 添加资质及补贴信息、荣誉信息
export function addHonorInfo(params) {
  return request({
    method: 'post',
    url: `honorInformation/addOrUpdateHonorInformation`,
    data: params
  })
}
// 删除资质及补贴信息、荣誉信息
export function delHonorInfo(params) {
  return request({
    method: 'post',
    url: `honorInformation/delHonorInformation`,
    data: params
  })
}
// 查询文件管理
export function findFileInfo(id) {
  return request({
    method: 'get',
    url: `fileManagement/findFileManagement?userId=${id}`,
  })
}
// 添加文件管理
export function addFileInfo(params) {
  return request({
    method: 'post',
    url: `fileManagement/addOrUpdateFileManagement`,
    data: params
  })
}
// 查询高管资质
export function findQuaInfo(params) {
  return request({
    method: 'post',
    url: `executiveQualification/findExecutiveQualification`,
    data: params
  })
}
// 添加或修改高管资质
export function addQuaInfo(params) {
  return request({
    method: 'post',
    url: `executiveQualification/addOrUpdateExecutiveQualification`,
    data: params
  })
}
// 删除高管资质
export function delQuaInfo(id) {
  return request({
    method: 'get',
    url: `executiveQualification/delExecutiveQualification?id=${id}`
  })
}
// 审批
export function applyRecord(params) {
  return request({
    method: 'post',
    url: `applyRecord/approvalProcess`,
    data: params
  })
}
// 查看原因：查询申请记录
export function failReason(id) {
  return request({
    method: 'get',
    url: `applyRecord/findApplyRecord?id=${id}`
  })
}
// 整改
export function updateApplyRecord(id) {
  return request({
    method: 'get',
    url: `applyRecord/updateApplyRecord?id=${id}`
  })
}
/**
 *统计表
 */
// 查询会员类型数量
export function findMemberTypeNum() {
  return request({
    method: 'get',
    url: `statisticalFigure/findMemberTypeNum`
  })
}
// 机构数统计
export function findMechanismStatistic(typeName) {
  return request({
    method: 'get',
    url: `statisticalFigure/findMechanismStatistic?businessType=${typeName}`
  })
}
// 信用行业协会收入增长比较
export function findIndustryGrowth() {
  return request({
    method: 'get',
    url: `statisticalFigure/findIndustryGrowth`
  })
}
// 信用行业机构收入统计
export function findIndustryStatistic() {
  return request({
    method: 'get',
    url: `statisticalFigure/findIndustryStatistic`
  })
}
// 营业收入机构排名
export function findIndustryRanking(params) {
  return request({
    method: 'post',
    url: `statisticalFigure/findIndustryRanking`,
    data: params
  })
}
// 各年份业务收入统计
export function findBusinessIncome(params) {
  return request({
    method: 'post',
    url: `statisticalFigure/findBusinessIncome`,
    data: params
  })
}
// 各年份业务收入及其增长率统计
export function findIncomeStatistic(params) {
  return request({
    method: 'post',
    url: `statisticalFigure/findIncomeStatistic`,
    data: params
  })
}
// 机构人数统计
export function findCompanyNumber(year) {
  return request({
    method: 'get',
    url: `statisticalFigure/findCompanyNumber?year=${year}`
  })
}

// 从业人员数量统计
export function findPractitionerNumber() {
  return request({
    method: 'get',
    url: `statisticalFigure/findPractitionerNumber`
  })
}
// 从业人员学历构成情况
export function findPractitionerEducation(year) {
  return request({
    method: 'get',
    url: `statisticalFigure/findPractitionerEducation?year=${year}`
  })
}
// 从业人员从业年限构成情况
export function findPractitionerYear(year) {
  return request({
    method: 'get',
    url: `statisticalFigure/findPractitionerYear?year=${year}`
  })
}
// 从业人员专业技术职称构成情况
export function findPractitionerTechnical(year) {
  return request({
    method: 'get',
    url: `statisticalFigure/findPractitionerTechnical?year=${year}`
  })
}



/**
 *调查表
 */
// 查询调查表基础信息
export function questionnaireInfo(params) {
  return request({
    method: 'post',
    url: `questionnaireInformation/findQuestionnaireInformation`,
    data: params
  })
}

// // 添加或修改调查表基础信息
// export function addOrUpdateQues(params) {
//   return request({
//     method: 'post',
//     url: `questionnaireInformation/addOrUpdateQuestionnaireInformation`,
//     data: params
//   })
// }
// // 提交某一年的调查表：发起审批
// export function submitQuestion(params) {
//   return request({
//     method: 'post',
//     url: `questionnaireInformation/submitQuestion`,
//     data: params
//   })
// }
// 导入调查表
export function importQuesInfo(params) {
  return request({
    method: 'post',
    url: `questionnaireInformation/importQuestionnaireInformation`,
    data: params
  })
}
/**
 *协会管理员公司信息
 */
// 知识产权-商标信息
export function findBrand(name) {
  return request({
    method: 'get',
    url: `companyInformation/findBrand?companyName=${name}`
  })
}
// 司法判决信息-著作权
export function findCopyRight(name) {
  return request({
    method: 'get',
    url: `companyInformation/findCopyRight?companyName= ${name}`
  })
}
// 司法判决信息-裁判文书
export function findNegFact(name) {
  return request({
    method: 'get',
    url: `companyInformation/findNegFact?companyName=${name}`
  })
}
// 司法判决信息-失信人执行公告
export function findNegFact1(name) {
  return request({
    method: 'get',
    url: `companyInformation/findNegFact1?companyName=${name}`
  })
}
// 司法判决信息-被执行人公告
export function findNegFact2(name) {
  return request({
    method: 'get',
    url: `companyInformation/findNegFact2?companyName=${name}`
  })
}
// 股东信息&企业对外投资 调商安信接口
export function moduleInformation(name, type) {
  return request({
    method: 'get',
    url: `login/moduleInformation?companyName=${name}&type=${type}`
  })
}
// 商安信登录接口
export function loginMonitoring(params) {
  return request({
    method: 'post',
    url: `login/loginMonitoring`,
    data: params
  })
}
// 查询所有文章信息
export function findArticleInfoList(params) {
  return request({
    method: 'post',
    url: `sysNotice/findArticleInformationList`,
    data: params
  })
}
// 查询文章信息详情
export function findArticleInfo(id) {
  return request({
    method: 'get',
    url: `sysNotice/findArticleInformationById?id=${id}`
  })
}
/**
 *会管我的提醒
 */
// 我的提醒详情页面
export function findTodoDetail(params) {
  return request({
    method: 'post',
    url: `todoInformation/findTodoDetail`,
    data: params
  })
}
// 会员编辑
export function addOrUpdateMember(params) {
  return request({
    method: 'post',
    url: `user/addOrUpdateMember`,
    data: params
  })
}
// 会员修改公司名
export function updMemberName(params) {
  return request({
    method: 'post',
    url: `user/updMemberName`,
    data: params
  })
}
// 查询财务状况tab栏信息
export function findFinancialInformation(userId) {
  return request({
    method: 'get',
    url: `questionnaireInformation/findFinancialInformation?userId=${userId}`
  })
}
// 查询业务情况tab栏信息
export function findBusinessInformation(userId) {
  return request({
    method: 'get',
    url: `questionnaireInformation/findBusinessInformation?userId=${userId}`
  })
}
// 管理员备注
export function findRemarkList(params) {
  return request({
    method: 'post',
    url: `remarkInformation/findRemarkList`,
    data: params
  })
}
// 管理员添加备注
export function addRemark(params) {
  return request({
    method: 'post',
    url: `remarkInformation/addRemark`,
    data: params
  })
}
// 查询高管及其他任职信息
export function findExecutive(params) {
  return request({
    method: 'post',
    url: `companyInformation/findExecutiveOtherJobInformation`,
    data: params
  })
}
// 添加或修改高管及其他任职信息
export function addOrUpdateExecutive(params) {
  return request({
    method: 'post',
    url: `companyInformation/addOrUpdateExecutiveInformation`,
    data: params
  })
}
// 删除高管及其他任职信息
export function delExecutive(id) {
  return request({
    method: 'get',
    url: `companyInformation/delExecutiveInformation?id=${id}`
  })
}
// 查询平台管理员名字
export function queryUserNameList() {
  return request({
    method: 'post',
    url: `user/queryUserNameList`
  })
}
// 导出营业收入机构排名
export function exportExcel(params) {
  return request({
    method: 'post',
    url: `statisticalFigure/exportExcel`,
    data: params,
    responseType: 'blob'
  })
}
// 查询所有会员会费
export function findMembershipFeeList(year) {
  return request({
    method: 'get',
    url: `membershipFee/findMembershipFeeList?year=${year}`
  })
}
// 添加或修改会员会费
export function addOrUpdateMembershipFee(params) {
  return request({
    method: 'post',
    url: `membershipFee/addOrUpdateMembershipFee`,
    data: params
  })
}
// 添加或修改会员会费
export function findPaymentHistoryList(userId) {
  return request({
    method: 'get',
    url: `membershipFee/findPaymentHistoryList?userId=${userId}`
  })
}

// 修改缴费历史的缴费状态
export function updatePaymentHistory(params) {
  return request({
    method: 'post',
    url: `membershipFee/updatePaymentHistory`,
    data: params
  })
}
// 查询缴费记录所用信息
export function findPaymentInformation(params) {
  return request({
    method: 'post',
    url: `membershipInformation/findPaymentInformation`,
    data: params
  })
}
// 查询会籍信息
export function findMembershipInformation(params) {
  return request({
    method: 'post',
    url: `membershipInformation/findMembershipInformation`,
    data: params
  })
}
// 修改会籍信息
export function updateMembershipInformation(params) {
  return request({
    method: 'post',
    url: `membershipInformation/updateMembershipInformation`,
    data: params
  })
}
// 添加或修改调查表基础信息
export function addOrUpdateQuestionnaireInfo(params) {
  return request({
    method: 'post',
    url: `questionnaireInformation/addOrUpdateQuestionnaireInformation`,
    data: params
  })
}
// 批量放入或撤回轮播
export function addOrWithdrawNotice(params) {
  return request({
    method: 'post',
    url: `sysNotice/addOrWithdrawNotice`,
    data: params
  })
}
// 发布通告记录
export function updateNotice(id) {
  return request({
    method: 'get',
    url: `sysNotice/updateNotice?id=${id}`
  })
}
// 导入调查表
export function importQuestionnaireInfo(params) {
  return request({
    method: 'post',
    url: `questionnaireInformation/importQuestionnaireInformation`,
    data: params
  })
}
// 添加会员时模糊搜索会员名
export function findCompanyIndex(companyName, count, rowCount) {
  return request({
    method: 'get',
    url: `login/findCompanyIndex?companyName=${companyName}&current=${count}&rowCount=${rowCount}`
  })
}